module.exports = __webpack_public_path__ + "static/img/memberBg.70ebc1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/member/image/memberBg.png
// module id = B4ja
// module chunks = 0